/* eslint-disable */
import { mapGetters, mapState } from 'vuex'
import TaskResultModal from '@/components/TaskResultModal'
import { getLatestMessage } from '@/services/message'

export default {
  components: {
    TaskResultModal
  },
  data() {
    return {
      link: [
        {
          path: '/message/center',
          title: this.$t('camcard_share'),
          key: 'share',
          num: 0,
          log: 'click_card_share',
          icon: 'icomoon-card',
          show: true
        },
        {
          path: '/message/taskcenter',
          title: this.$t('task_share'),
          key: 'task',
          num: 0,
          log: 'click_task_cooperate',
          icon: 'icomoon-task',
          show: true
        },
        {
          path: '/message/applylist',
          title: this.$t('apply_list'),
          key: 'apply',
          num: 0,
          log: 'click_tobe_join_colleagues',
          icon: 'icomoon-title',
          show: false
        },
        {
          path: '/message/hrchange',
          title: this.$t('hrchange_show'),
          key: 'hr',
          num: 0,
          log: 'click_hr_change',
          icon: 'icomoon-hr',
          show: false
        },
        {
          path: '/message/uploadcard',
          title: this.$t('card_upload'),
          key: 'upload',
          num: 0,
          width: 16,
          log: 'click_card_upload_log',
          icon: 'icomoon-upload',
          show: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      CP: 'user/CP'
    }),
    ...mapState('user', {
      msgNum: state => state.msgData
    })
  },
  watch: {
    msgNum(v) {
      this.link[0].num = v.share_num || 0
      this.link[1].num = v.task_num || 0
      this.link[2].num = v.apply_num || 0
      this.link[3].num = v.hrchange_num || 0
      this.link[4].num = v.upload_card_num || 0
    }
  },
  methods: {
    async getData() {
      try {
        const data = await getLatestMessage({})
        if (data.errno == 0) {
          this.$store.commit('user/setMsgNum', data?.data || {})
        }
      } catch (e) {}
    },
    go(path, log) {
      this.$log.action(log)
      this.$router.push({ path })
    }
  },
  created() {
    const { privilege_info = {}, role = 0 } = this.$store.state.user.user_info || {}
    this.link[0].show = role !== 2
    this.link[1].show = role === 0 || role === 1
    this.link[2].show = privilege_info.show_manage === 'y'
    this.link[3].show =
      privilege_info.show_hrchange === 'y' &&
      privilege_info.is_read_only === 'n' &&
      privilege_info.is_normal_admin === 'n'
    this.link[4].show = role !== 2
  },
  mounted() {
    this.getData()
    this.$log.page('CCB_web_message')
  }
}
